// extracted by mini-css-extract-plugin
module.exports = {"button":"ScrollButton_button__s079j","buttonLeft":"ScrollButton_buttonLeft__mW9th","icon":"ScrollButton_icon__3L70h"};